import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['quality'], // 为了获取基础路由
    };
};
export const qualityToPathNameMap = {
    quality1070: ({ businessKey }) => commonFunc(`/inspection/selfCheck/detail?id=${businessKey}`),
    quality1090: ({ businessKey }) => commonFunc(`/inspection/mutualCheck/detail?id=${businessKey}`),
    quality1080: ({ businessKey }) => commonFunc(`/inspection/specialCheck/detail?id=${businessKey}`),
    //工序样板管理
    quality1030: ({ businessKey }) => commonFunc(`/plan/processSample/detail?id=${businessKey}`),
    // 质量行为奖惩
    quality1040: ({ businessKey }) => commonFunc(`/reward/behaviorRewardPunish/detail?id=${businessKey}`),
    // 质量事故报告
    quality1050: ({ businessKey }) => commonFunc(`/control/incidentReport/detail?id=${businessKey}`),
    // 通病防控
    quality1130: ({ businessKey }) => commonFunc(`/plan/comprobPrevent/detail?id=${businessKey}`),
    // 责任制度
    quality1140: ({ businessKey }) => commonFunc(`/plan/liabilitySystem/detail?id=${businessKey}`),
    // 验收标准
    quality1150: ({ businessKey }) => commonFunc(`/plan/acceptanceCriteria/detail?id=${businessKey}`),
    // 材料进场
    quality2200: ({ businessKey }) => commonFunc(`/access/materialApproach/detail?id=${businessKey}`),
    // 隐蔽管理
    quality2020: ({ businessKey }) => commonFunc(`/control/hide/detail?id=${businessKey}`),
    // 施工测量
    quality2030: ({ businessKey }) => commonFunc(`/control/measure/detail?id=${businessKey}`),
    // 实测实量
    quality2080: ({ businessKey }) => commonFunc(`/control/realAspect/detail?id=${businessKey}`),
    // 检查检验记录
    quality2050: ({ businessKey }) => commonFunc(`/control/inspectRecord/detail?id=${businessKey}`),
    // 砼砂浆统计评定
    quality2070: ({ businessKey }) => commonFunc(`/control/evaluate/detail?id=${businessKey}`),
    // 试验记录
    quality2090: ({ businessKey }) => commonFunc(`/control/testRecord/detail?id=${businessKey}`),
    // 设备系统测试调试
    quality2060: ({ businessKey }) => commonFunc(`/control/equipmentTest/detail?id=${businessKey}`),
    // 检验批/工序验收
    quality3010: ({ businessKey }) => commonFunc(`/evaluation/accept/detail?id=${businessKey}`),
    // 分项/单元工程验收
    quality3050: ({ businessKey }) => commonFunc(`/evaluation/subentry/detail?id=${businessKey}`),
    // 子分部工程验收
    quality3060: ({ businessKey }) => commonFunc(`/evaluation/subsegment/detail?id=${businessKey}`),
    // 分部工程验收
    quality3030: ({ businessKey }) => commonFunc(`/evaluation/segment/detail?id=${businessKey}`),
    // 专项验收
    quality3040: ({ businessKey }) => commonFunc(`/evaluation/special/detail?id=${businessKey}`),
    // 完工验收
    quality4070: ({ businessKey }) => commonFunc(`/evaluation/projectCompleted/detail?id=${businessKey}`),
    // 竣工验收报告
    quality4040: ({ businessKey }) => commonFunc(`/evaluation/completedReport/detail?id=${businessKey}`),
    // 质量保修书
    quality4020: ({ businessKey }) => commonFunc(`/evaluation/guarantee/detail?id=${businessKey}`),
    // 单位工程竣工验收
    quality4050: ({ businessKey }) => commonFunc(`/evaluation/unit/detail?id=${businessKey}`),
    // 竣工备案
    quality4030: ({ businessKey }) => commonFunc(`/evaluation/completedRecord/detail?id=${businessKey}`),
    //预警记录
    quality7010: ({ businessKey }) => commonFunc(`/warning/warningRecord`),
    // V1.3
    //施工记录
    quality3070: ({ businessKey }) => commonFunc(`/control/constructionRecord/detail?id=${businessKey}`),
    //见证送检
    quality3080: ({ businessKey }) => commonFunc(`/control/witness/detail?id=${businessKey}`),
    //试验报告反馈
    quality3090: ({ businessKey }) => commonFunc(`/control/witnessFeedback/detail?id=${businessKey}`),
};
